// extracted by mini-css-extract-plugin
module.exports = {"loginPanel":"styles_loginPanel__1w6wK","title":"styles_title__1cEeR","submit":"styles_submit__LUm65"};